export default __webpack_public_path__ + "static/media/brandballoon-four.28ea2ba3.png";